document.querySelectorAll(".resources-links__tab-title").forEach((tab) => {
    tab.addEventListener("click", () => {
        tab.parentElement.classList.toggle("active");
    });
});